import { STORAGEKEY_PRIVACYPOLICY_CONFIRMED } from 'config/constants';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { getCompanyExtraLogo } from 'utils/helpers';

PageFooter.propTypes = {
    apiCaller: PropTypes.func.isRequired
};

export default function PageFooter(props) {
    const [privacyConfirmed, setPrivacyConfirmed] = useState(!!localStorage.getItem(STORAGEKEY_PRIVACYPOLICY_CONFIRMED));

    const hasExtraLogo = getCompanyExtraLogo();

    const confirmPrivacyPolicy = () => {
        setPrivacyConfirmed(true);
        localStorage.setItem(STORAGEKEY_PRIVACYPOLICY_CONFIRMED, true);
    };

    if (privacyConfirmed && !hasExtraLogo) return null;

    return (
        <div className='AppContainer__link-pdfs'>
            {!privacyConfirmed && <div className='AppContainer__link-pdfs__contents'>
                <span>We value your privacy, therefore we only use cookies to provide you with  the best experience. By continuing to our  site we  will assume {"you're"} happy with that.</span>
                <div onClick={confirmPrivacyPolicy} className='AppContainer__link-pdfs__pdf' >Ok</div>
                <a className='AppContainer__link-pdfs__pdf' target='_blank' href='/pdf/privacy-policy-23-06-2025.pdf'>Privacy Policy</a>
            </div>}

            {hasExtraLogo && <img src={hasExtraLogo} className='AppContainer__link-pdfs__extralogo' alt='extra-logo'/>}
        </div>
    );
}
